import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FileUpload from '@material-ui/icons/FileUpload';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AutoComplete from '../../shared/AutoComplete';
import ErrorBar from '../../shared/ErrorBar';
import { convertIdToName } from '../../../helpers/convertIdToName';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
  },
});


class ExpenseAccountForm extends Component {

  state = {
      account_name: '',
      expense_account_id: '',
      errMessages: this.props.errMessages,
    };

  componentWillReceiveProps(nextProps) {
    this.setState({
      errMessages: nextProps.errMessages
    });
  }

  onExpenseAccountSelect = expenseAccount => {
    const expense_account_id = this.props.expense_accounts.filter(dataSet => {
      return dataSet.account_name.toLowerCase() === expenseAccount.toLowerCase()
    });
    this.setState({ expense_account_id: expense_account_id[0].id.toString() });
  }

  onSubmit = e => {
    const { expense_account_id, account_name } = this.state;
    e.preventDefault();
    if (this.props.editMode) {
      return this.props.onFormActionSubmit(
        { expense_account_id, account_name}
      );
    }
    return this.props.onFormActionSubmit({
      account_name
    });
  }

  handleCloseError = (remove) => {
    const newErrMessages = this.state.errMessages.filter((errMessage, index) => index !== remove)
    this.setState({
      errMessages: newErrMessages
    });
  }

  handleChange = name => event => {
    console.log(name);
      this.setState({
        [name]: event.target.value,
      });
    };

  renderErrMessages() {
    return <ErrorBar messages={this.state.errMessages} onClick={this.handleCloseError}/>
  }

  render() {
    const { classes, editMode, role } = this.props;
    return (
      <div>
        <form>

        { editMode ?  (
          <AutoComplete suggestionCount={15} data={this.props.expense_accounts} dataKey={'account_name'} unAuthorized={role !== 'admin'} onItemSelect={this.onExpenseAccountSelect} value={convertIdToName(this.state.expense_account_id, this.props.expense_accounts, "account_name")} fieldLabel="Expense Account" />) : ''}
        <FormControl className={classes.formControl}>
        <InputLabel htmlFor="name-simple">Account Name</InputLabel>
        <Input fullWidth id="name-simple" value={this.state.account_name} onChange={this.handleChange('account_name')} />
          </FormControl>
          {
            this.renderErrMessages()
          }
        </form>
        <Button variant="raised" disabled={this.props.loading || (editMode && this.props.role !== 'admin' )} color="primary" className={classes.button} onClick={this.onSubmit}>
          {this.props.loading ? <CircularProgress className={classes.progress} size={25} /> :
          <FileUpload className={classes.leftIcon} aria-label={editMode ? 'Update' : 'Create'} />
          }
          { editMode ? 'Update' : 'Create' }
        </Button>
      </div>
    );
  }
}

const mapStateToProps = ({ divisions, auth, errors, appLoading, expense_accounts }) => {
  const { errMessage } = errors;
  const { loading } = appLoading;
  const errMessages = errMessage.split(", ")[0] === "" ? [] : errMessage.split(", ");
  const { role } = auth;
  return {
    expense_accounts,
    loading,
    divisions,
    role,
    errMessages
  };
};


export default compose(
  withStyles(styles, {
    name: 'ExpenseAccountForm',
}), connect( mapStateToProps ))(ExpenseAccountForm);



// WEBPACK FOOTER //
// ./src/components/admin/expenseAccounts/ExpenseAccountForm.js